import { Collection, ICollectionSet } from "@maxeb/art-sdk";
import { SetState, State } from "./State";

export async function get(state: State, setState: SetState) {
  setState({ ...state, status: "pending" });
  try {
    const result = await Collection.get(
      { id: state.id },
      ["id", "name", "thumb", "description", "team", "public", "weight"],
      20
    );

    if (result.isSuccess() && result.body.data.length === 1) {
      const data = result.body.data[0];
      setState({ ...state, status: "ok", data });
      if (state.onChange) state.onChange(data);
      return data;
    }
  } catch (err) {
    console.error(err);
  }
  setState({ ...state, status: "error" });
}
export async function save(state: State, setState: SetState) {
  setState({ ...state, status: "pending" });

  try {
    const { data } = state;
    const set: ICollectionSet = {
      name: data.name,
      weight: data.weight,
      public: data.public || false,
      description: data.description || null,
    };

    const response = await Collection.update(set, { id: state.id });

    if (response.isSuccess()) {
      setState({ ...state, status: "success" });
      return setTimeout(() => {
        setState({ ...state, status: "init" });
      }, 1000);
    } else {
      const errors = response.getErrors({
        "body.name": "name",
        "body.birthdate": "birthdate",
        "body.placeOfBirth": "placeOfBirth",
        "body.description": "description",
      });

      if (Object.keys(errors).length)
        return setState({ ...state, status: "ok", errors });
    }
  } catch (error) {
    console.error(error);
  }

  return setState({ ...state, status: "error" });
}
export async function remove(
  props: { navigate: (to: string) => void },
  state: State,
  setState: SetState
) {
  const newState = { ...state, confirmDelete: false };
  setState({ ...newState, status: "pending" });

  try {
    const response = await Collection.remove({ id: state.id });

    if (response.isSuccess()) {
      setState({ ...newState, status: "success" });
      return setTimeout(() => {
        props.navigate("/collections");
      }, 1000);
    }
  } catch (error) {
    console.error(error);
  }

  return setState({ ...newState, status: "error" });
}
export async function reload(state: State, setState: SetState) {
  setState({
    ...state,
    status: "success",
  });
  setTimeout(() => {
    setState({
      ...state,
      status: "init",
    });
  }, 1000);
}
export function setPending(state: State, setState: SetState) {
  setState({
    ...state,
    status: "pending",
  });
}
export function setData(
  props: { data: State["data"] },
  state: State,
  setState: SetState
) {
  const { data } = props;
  setState({
    ...state,
    data,
  });
}
